import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import { myLightTheme, myDarkTheme } from '../theme/myTheme';

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    ThemeBlueprint.make({
      name: 'light',
      params: {
        theme: {
          id: 'light',
          title: 'Light Theme',
          variant: 'light',
          Provider: ({ children }) => (
            <UnifiedThemeProvider theme={myLightTheme} children={children} />
          ),
        },
      },
    }),
    ThemeBlueprint.make({
      name: 'dark',
      params: {
        theme: {
          id: 'dark',
          title: 'Dark Theme',
          variant: 'dark',
          Provider: ({ children }) => (
            <UnifiedThemeProvider theme={myDarkTheme} children={children} />
          ),
        },
      },
    }),
  ],
});
